import { render, staticRenderFns } from "./ExamplesBlock.vue?vue&type=template&id=18f6d0bb&scoped=true"
import script from "./ExamplesBlock.vue?vue&type=script&lang=js"
export * from "./ExamplesBlock.vue?vue&type=script&lang=js"
import style0 from "./ExamplesBlock.vue?vue&type=style&index=0&id=18f6d0bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6d0bb",
  null
  
)

export default component.exports